<template>
  <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li>
            <router-link :to="{name: 'exercise'}">Lớp học</router-link>
            <i
              class="secondary-color-txt fa fa-angle-right"
              style="margin-left: 5px;margin-right: 5px"
            ></i>
            <span>
              <router-link :to="{ path: '/trung-tam-tro-giup' }">Lớp 01 - A6 Môn Tiếng Việt</router-link>
            </span>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
export default {
    name: "BreadcrumbClass"
}
</script>

<style>

</style>